/** "client" module DTOs unique keys */
export enum ClientDtoKeysEnum {
  /** Bank details collapse API request body */
  BANK_DETAILS_COLLAPSE_FORM_DTO = 'client/bank-details-collapse-form.dto',
  /** Bank details duplicate relations statistics */
  BANK_DETAILS_DUPLICATE_STAT_DTO = 'client/bank-details-duplicate-stat.dto',
  /** Bank details duplicate data */
  BANK_DETAILS_DUPLICATE_DTO = 'client/bank-details-duplicate.dto',
  /** Bank details duplicates group response body */
  BANK_DETAILS_DUPLICATES_GROUP_DTO = 'client/bank-details-duplicates-group.dto',
  /** Bank details duplicates search API response body */
  BANK_DETAILS_DUPLICATES_PAGE_DTO = 'client/bank-details-duplicates-page.dto',
  /** Bank details duplicates search API query parameters */
  BANK_DETAILS_DUPLICATES_QUERY_DTO = 'client/bank-details-duplicates-query.dto',
  /** All bank details list API query parameters */
  BANK_DETAILS_QUERY_DTO = 'client/bank-details-query.dto',
  /** Bank details response body */
  BANK_DETAILS_FIND_DTO = 'client/bank-details-find.dto',
  /** Bank details creation request body */
  BANK_DETAILS_FORM_DTO = 'client/bank-details-form.dto',
  /** Bank details updating request body */
  BANK_DETAILS_UPDATE_FORM_DTO = 'client/bank-details-update-form.dto',
  /** Client creation API request body */
  CLIENT_CREATE_DTO = 'client/client-create.dto',
  /** Additional client deletion options */
  CLIENT_DELETE_QUERY_DTO = 'client/client-delete-query.dto',
  /** Client list APIs common query parameters */
  CLIENT_FILTERS_DTO = 'client/client-filters.dto',
  /** Client selection settings */
  CLIENT_SELECT_DTO = 'client/client-select.dto',
  /** Client sorting settings */
  CLIENT_SORT_DTO = 'client/client-sort.dto',
  /** Client find one API query parameters with additional options */
  CLIENT_FIND_ONE_QUERY_DTO = 'client/client-find-one-query.dto',
  /** Response body for client - logical group of counterparties. */
  CLIENT_FIND_DTO = 'client/client-find.dto',
  /** Client create or update request body */
  CLIENT_FORM_DTO = 'client/client-form.dto',
  /** Clients flat list API query parameters */
  CLIENTS_LIST_FLAT_QUERY_DTO = 'client/clients-list-flat-query.dto',
  /** Clients list API query parameters */
  CLIENTS_LIST_QUERY_DTO = 'client/clients-list-query.dto',
  /** Clients list slice response body */
  CLIENTS_LIST_PAGE_DTO = 'client/clients-list-page.dto',
  /** Client documents widget response body */
  CLIENT_DOCUMENTS_WIDGET_FIND_DTO = 'client/client-documents-widget-find.dto',
  /** Client BRS tasks widget data - last N created BRS tasks and total number of BRS tasks */
  CLIENT_BRS_TASKS_WIDGET_FIND_DTO = 'client/client-brs-tasks-widget-find.dto',
  /** Client deals widget data - last N created deals and total number of deals */
  CLIENT_DEALS_WIDGET_FIND_DTO = 'client/client-deals-widget-find.dto',
  /** Client helpdesk tasks widget data - last N created HD tasks and total number of HD tasks */
  CLIENT_HELPDESK_TASKS_WIDGET_FIND_DTO = 'client/client-helpdesk-tasks-widget-find.dto',
  /** Client projects widget data - last N created projects and total number of projects */
  CLIENT_PROJECTS_WIDGET_FIND_DTO = 'client/client-projects-widget-find.dto',
  /** Client deals widget query params */
  CLIENT_DEALS_WIDGET_QUERY_DTO = 'client/client-deals-widget-query.dto',
  /** Client projects widget query params */
  CLIENT_PROJECTS_WIDGET_QUERY_DTO = 'client/client-projects-widget-query.dto',
  /** Client documents widget query params */
  CLIENT_DOCUMENTS_WIDGET_QUERY_DTO = 'client/client-documents-widget-query.dto',
  /** Client HD tasks widget query params */
  CLIENT_HELPDESK_TASKS_WIDGET_QUERY_DTO = 'client/client-helpdesk-tasks-widget-query.dto',
  /** Client HD tasks assign API request body */
  CLIENT_HELPDESK_TASKS_FORM_DTO = 'client/client-helpdesk-tasks-form.dto',
  /** Client create request body */
  CLIENT_SET_FREE_TRANSIT_TASK_FORM_DTO = 'client/client-set-free-transit-task-form.dto',
  /** Find default counteparty for balance sheet report API response body */
  CONTRAGENT_BALANCE_SHEET_DEFAULT_FIND_DTO = 'client/contragent-balance-sheet-default-find.dto',
  /** Set default counteparty for balance sheet report API response body */
  CONTRAGENT_BALANCE_SHEET_DEFAULT_FORM_DTO = 'client/contragent-balance-sheet-default-form.dto',
  /** Assign client to counterparty API URL params */
  CONTRAGENT_ASSIGN_CLIENT_PARAMS_DTO = 'client/contragent-assign-client-params.dto',
  /** Assign external user to counterparty API URL params */
  CONTRAGENT_ASSIGN_EXTERNAL_USER_PARAMS_DTO = 'client/contragent-assign-external-user-params.dto',
  /** Counterparty card API query parameters (additional options) */
  CONTRAGENT_CARD_QUERY_DTO = 'clients/contragent-card-query.dto',
  /** Counterparty delete API query parameters (additional options) */
  CONTRAGENT_DELETE_QUERY_DTO = 'clients/contragent-delete-query.dto',
  /** Counterparty response body */
  CONTRAGENT_FIND_DTO = 'client/contragent-find.dto',
  /** Counterparty create or update requests body */
  CONTRAGENT_FORM_DTO = 'client/contragent-form.dto',
  /** Counterparty own filters */
  CONTRAGENT_OWN_FILTERS_DTO = 'client/contragent-own-filters.dto',
  /** Counterparties list JSON "page" query parameters */
  CONTRAGENT_PAGE_QUERY_DTO = 'client/contragent-page-query.dto',
  /** Counterparties list JSON "page" */
  CONTRAGENT_PAGE_DTO = 'client/contragent-page.dto',
  /** Contragent partial update request body */
  CONTRAGENT_PARTIAL_FORM_DTO = 'client/contragent-partial-form.dto',
  /** Counteparties lists APIs base query parameters */
  CONTRAGENT_QUERY_DTO = 'client/contragent-query.dto',
  /** Related counterparty objects statistics */
  CONTRAGENT_RELATED_OBJECTS_STAT_DTO = 'client/contragent-related-objects-stat.dto',
  /** Numbers of counterparty relations */
  CONTRAGENT_RELATIONS_COUNTS_DTO = 'client/contragent-relations-counts.dto',
  /** Counterparty selection options */
  CONTRAGENT_SELECT_DTO = 'client/contragent-select.dto',
  /** Counterparty sorting options */
  CONTRAGENT_SORT_DTO = 'client/contragent-sort.dto',
  /** Duplicated counterparty */
  CONTRAGENT_DUPLICATE_DTO = 'client/contragent-duplicate.dto',
  /** Group of duplicated counterparties */
  CONTRAGENT_DUPLICATES_GROUP_DTO = 'client/contragent-duplicates-group.dto',
  /** Duplicated counterparties slice */
  CONTRAGENT_DUPLICATES_PAGE_DTO = 'client/contragent-duplicates-page.dto',
  /** Counterparties collapse request body */
  CONTRAGENT_COLLAPSE_FORM_DTO = 'client/contragent-collapse-form.dto',
  /** Counterparty history response */
  CONTRAGENT_HISTORY_FIND_DTO = 'client/contragent-history-find.dto',
  /** Counterparty history page response */
  CONTRAGENT_HISTORY_PAGE_DTO = 'client/contragent-history-page.dto',
  /** Common person (company or counterparty) response body */
  PERSON_FIND_DTO = 'client/person-find.dto',
  /** Common person (company or counterparty) create or update request body */
  PERSON_FORM_DTO = 'client/person-form.dto',
  /** Person external search query parameters */
  PERSON_EXTERNAL_SEARCH_QUERY_DTO = 'client/person-external-search-query.dto',
  /** Person passport data */
  PERSON_PASSPORT_DATA_DTO = 'client/person-passport-data.dto',
  /** Person find base query parameters */
  PERSON_FIND_BASE_QUERY_DTO = 'client/person-find-base-query.dto',
  /** Activity own filters */
  ACTIVITY_FILTERS_DTO = 'client/activity-filters.dto',
  /** Activity find one API query paramaters */
  ACTIVITY_FIND_ONE_QUERY_DTO = 'client/activity-find-one-query.dto',
  /** Activity response body */
  ACTIVITY_FIND_DTO = 'client/activity-find.dto',
  /** Activity create or update requests body */
  ACTIVITY_FORM_DTO = 'client/activity-form.dto',
  /** Activity list JSON "page" */
  ACTIVITY_PAGE_DTO = 'client/activity-page.dto',
  /** Activity APIs base query parameters */
  ACTIVITY_QUERY_DTO = 'client/activity-query.dto',
  /** Activity export to file API query parameters */
  ACTIVITY_EXPORT_QUERY_DTO = 'client/activity-export-query.dto',
  /** Activity selection settings */
  ACTIVITY_SELECT_DTO = 'client/activity-select.dto',
  /** Activity sorting settings */
  ACTIVITY_SORT_DTO = 'client/activity-sort.dto',
  /** Company response body */
  COMPANY_FIND_DTO = 'client/company-find.dto',
  /** Company statistics response body */
  COMPANY_STATISTICS_FIND_DTO = 'client/company-statistics-find.dto',
  /** Company query params body */
  COMPANY_FIND_QUERY_DTO = 'client/company-find-query.dto',
  /** Company list response body */
  COMPANY_FIND_RESULT_DTO = 'client/company-find-result.dto',
  /** Company find many API query parameters */
  COMPANY_FIND_MANY_QUERY_DTO = 'client/company-find-many-query.dto',
  /** Company export to file API query parameters */
  COMPANY_EXPORT_QUERY_DTO = 'client/company-export-query.dto',
  /** Company find one API query parameters */
  COMPANY_FIND_ONE_QUERY_DTO = 'client/company-find-one-query.dto',
  /** Company find many API response body */
  COMPANY_PAGE_DTO = 'client/company-page.dto',
  /** Company selection settings */
  COMPANY_SELECT_DTO = 'client/company-select.dto',
  /** Company sorting settings */
  COMPANY_SORT_DTO = 'client/company-sort.dto',
  /** Company registry group-first sorting query parameter */
  COMPANY_SORT_BY_GROUP_FIRST_QUERY_DTO = 'client/company-sort-by-group-first-query.dto',
  /** Company request body */
  COMPANY_FORM_DTO = 'client/company-form.dto',
  /** Compaty partial update request body */
  COMPANY_PARTIAL_FORM_DTO = 'client/company-partial-form.dto',
  /** Company group response response body */
  COMPANY_GROUP_FIND_DTO = 'client/company-group-find.dto',
  /** Standard company group search query */
  COMPANY_GROUP_QUERY_DTO = 'client/company-group-query.dto',
  /** Company group creation */
  COMPANY_GROUP_FORM_DTO = 'client/company-group-form.dto',
  /** Additional company deletion options */
  COMPANY_DELETE_QUERY_DTO = 'client/company-delete-query.dto',
  /** Response body for banner */
  BANNER_FIND_DTO = 'client/banner-find.dto',
  /** Banner create or update request body */
  BANNER_FORM_DTO = 'client/banner-form.dto',
  /** Banner partial update request body */
  BANNER_PARTIAL_FORM_DTO = 'client/banner-partial-form.dto',
  /** Banner list JSON "page" */
  BANNER_PAGE_DTO = 'client/banner-page.dto',
  /** Banner APIs base query parameters */
  BANNER_QUERY_DTO = 'client/banner-query.dto',
  /** Banner selection settings */
  BANNER_SELECT_DTO = 'client/banner-select.dto',
  /** Banner sorting settings */
  BANNER_SORT_DTO = 'client/banner-sort.dto',
  /** Banner list APIs common query parameters */
  BANNER_FILTERS_DTO = 'client/banner-filters.dto',
  /** Banner find one API query parameters */
  BANNER_FIND_ONE_QUERY_DTO = 'client/banned-find-one.query.dto',
  /** Banner response body for personal account mode */
  BANNER_PERSONAL_ACCOUNT_FIND_DTO = 'client/banner-personal-account-find.dto',
  /** Banner list JSON "page" for personal account mode */
  BANNER_PERSONAL_ACCOUNT_PAGE_DTO = 'client/banner-personal-account-page.dto',
  /** Contract settings APIs response body */
  CONTRACT_SETTINGS_FIND_DTO = 'client/contract-settings-find.dto',
  /** Contract settings save API request body */
  CONTRACT_SETTINGS_FORM_DTO = 'client/contract-settings-form.dto',
  /** Client's transit task limits by car category response body */
  TRANSIT_TASK_CAR_CATEGORY_LIMIT_FIND_DTO = 'client/transit-task-car-category-limit-find.dto',
  /** Client's transit task limits by car category create and update requests' body */
  TRANSIT_TASK_CAR_CATEGORY_LIMIT_FORM_DTO = 'client/transit-task-car-category-limit-form.dto',
}
